import cookie from 'cookie';
import pick from 'object.pick';

export class CookiePicker {
  constructor(cookies, keys = []) {
    if (typeof cookies === 'string') {
      this.cookies = cookie.parse(cookies);
    } else {
      this.cookies = cookies;
    }
    this.keys = keys;
  }

  getByKey(key) {
    return this.cookies[key];
  }

  @formatKeysArgs
  get(keys) {
    return pick(this.cookies, keys);
  }

  @formatKeysArgs
  string(keys) {
    const picked = this.get(keys);

    return Object.keys(picked).reduce((acc, key) => `${acc}${cookie.serialize(key, picked[key])};`, '');
  }
}

function formatKeysArgs(target, name, descriptor) {
  const fn = descriptor.value;

  descriptor.value = function (...args) {
    return fn.call(this, formatKeysArgsHelper.call(this, ...args));
  };
}

function formatKeysArgsHelper(keys, ...moreKeys) {
  if (!keys || !keys.length) {
    return this.keys || [];
  }
  if (Array.isArray(keys)) {
    return keys;
  }

  return [keys, ...moreKeys];
}

export default function cookiePicker(cookies, ...keys) {
  if (keys.length === 0) {
    return new CookiePicker(cookies);
  }

  return new CookiePicker(cookies, formatKeysArgsHelper(...keys)).string();
}
